import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import '../../../../assets/product-selection/itemConfig.scss';
import { useTypedSelector } from '../../../../hooks';
import { ItemWithPSAndLot } from '../../interface';
import { ItemForm } from './ItemForm';
import { SheetModal } from '../../../../brenger-shared-ui/components/layout/sheetlayout/SheetModal';

export const ItemEdit: React.FC<RouteComponentProps<{ uuid: string }>> = ({ match }) => {
  const history = useHistory();
  const item: ItemWithPSAndLot | undefined = useTypedSelector(
    state => state.generalTransport.product_selection.items
  ).find(psItem => psItem.ps_temp.uuid === match.params.uuid);
  const closeHandler = (): void => {
    // We go back in history because adding/editing should use 1 push and then replace. Going back makes us end up at /items, keeps the history logical when moving back/forward
    history.goBack();
  };

  if (!item) {
    return (
      <SheetModal isActive={true} closeHandler={closeHandler}>
        <div className="ps-modal--section">
          <Translate id={'request_flow.product_selection.item_not_found'} />
        </div>
      </SheetModal>
    );
  }
  return (
    <SheetModal isActive={true} closeHandler={closeHandler}>
      <ItemForm productGroup={item.ps_temp.group} existingItem={item} />
    </SheetModal>
  );
};
